import React from 'react';

import { useTranslation } from 'react-i18next';

import useStyles from './styles';

const ProgressLine = ({ value, progressString = '', completed = false }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const safeValue = value > 100 ? 100 : value;

  return (
    <div className={classes.progressWrap}>
      <div data-testid="watchedPercentage" className={classes.progressValue}>
        {safeValue}%
        <span className={classes.progressLabel}>
          {t(completed ? 'common.complete' : 'common.watched')}
        </span>
      </div>

      <div className={classes.progressString}>{progressString}</div>

      <div
        className={classes.progress}
        style={{
          width: `${safeValue}%`,
        }}
      />
    </div>
  );
};

export default ProgressLine;
